import React from 'react';
import { Typography } from '@mui/material';

const Disclaimers = ({ children, textAlign }) => React.Children.map(children, (c) => (
  <Typography key={c} variant="caption" textAlign={textAlign}>
    {c}
  </Typography>
));

export default Disclaimers;
